import { readFromLocalStorage, writeToLocalStorage, readFromSessionStorage, writeToSessionStorage } from './localStorage';
import { v4 as uuidv4 } from 'uuid';

const USER_ID_KEY = 'leora_user_id';

export interface UserSession {
  userId: string;
  sessionStartTime: string;
}

/**
 * Generate a unique user ID using UUID
 */
function generateUserId(): string {
  return uuidv4();
}

/**
 * Get or create a user session (only stores userId, no conversation tracking)
 */
export function getUserSession(): UserSession {
  const existingSession = readFromLocalStorage(USER_ID_KEY) as UserSession | null;
  
  if (existingSession?.userId) {
    return existingSession;
  }
  
  // Create new user session
  const newSession: UserSession = {
    userId: generateUserId(),
    sessionStartTime: new Date().toISOString()
  };
  
  writeToLocalStorage(USER_ID_KEY, newSession);
  return newSession;
}

/**
 * Get current conversation ID from session storage
 */
export function getCurrentConversationId(): string | null {
  return readFromSessionStorage('leora_current_conversation_id');
}

/**
 * Set current conversation ID in session storage
 */
export function setCurrentConversationId(conversationId: string): void {
  writeToSessionStorage('leora_current_conversation_id', conversationId);
}
